import React, { Component } from "react";
import { connect } from "react-redux";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import IconImg from "../../image/oclogo-small.png";
import Logout from "../auth/Logout";

class Header extends Component {
  renderHeader = () => {
    const { isSignedIn, isAdmin } = this.props.auth;
    return (
      <Navbar.Collapse id="pass-nav">
        <Nav className="mr-auto">
          <span>
            <Link
              className={
                this.props.title === "Welcome" ? "active nav-link" : "nav-link"
              }
              to="/welcome"
            >
              Welcome
            </Link>
          </span>

          <span>
            <Link
              to="/reminders"
              className={
                this.props.title === "Reminders"
                  ? "active nav-link"
                  : "nav-link"
              }
            >
              Reminders
            </Link>
          </span>

          {!isSignedIn && (
            <span>
              <Link
                to="/"
                className={
                  this.props.title === "Login" ? "active nav-link" : "nav-link"
                }
              >
                Login
              </Link>
            </span>
          )}

          {isSignedIn && (
            <span>
              <Link
                to="/training"
                className={
                  this.props.title === "Training"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                Training
              </Link>
            </span>
          )}

          {isSignedIn && (
            <span>
              <Link
                to="/vc"
                className={
                  this.props.title === "Vote Center"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                Vote Center
              </Link>
            </span>
          )}

          {isSignedIn && isAdmin && (
            <span>
              <Link
                to="/admin"
                className={
                  this.props.title === "Setup Times"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                Setup Times
              </Link>
            </span>
          )}
        </Nav>
        {isSignedIn && <Logout />}
      </Navbar.Collapse>
    );
  };

  render() {
    return (
      <header>
        <Navbar bg="dark" variant="dark" expand="lg" className="mb-3">
          <Link to="/" alt="VC PASS Home">
            <Navbar.Brand>
              <img src={IconImg} alt="Logo"></img>
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle aria-controls="pass-nav" />
          {this.renderHeader()}
        </Navbar>
      </header>
    );
  }
}

// Header.propTypes = {
//   siteTitle: PropTypes.string,
// }

// Header.defaultProps = {
//   siteTitle: `Orange County Registrar of Voters`,
// }

const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps)(Header);
